// Dibangkitkan dari assist-design-tokens.json v2.0.0. JANGAN disunting.
// Jalankan `pnpm --filter @assist/design-tokens build` setelah mengubah berkas ekspor Figma.
export const TOKEN_VERSION = "2.0.0";
/** Warna sebagai nilai heksadesimal: color.navy['70'] === '#223E7F'. */
export const color = {
    "navy": {
        "70": "#223E7F",
        "80": "#1B3466",
        "90": "#0F1B36"
    },
    "blue": {
        "10": "#DCE6FD",
        "55": "#2251FF",
        "65": "#0033EE",
        "75": "#0025AF",
        "05": "#F0F7FE"
    },
    "success": {
        "60": "#0F6B45",
        "70": "#0B5134",
        "05": "#EAF6F0"
    },
    "warn": {
        "60": "#9A4C07",
        "70": "#703705",
        "05": "#FCF0E1"
    },
    "danger": {
        "60": "#B02A24",
        "70": "#87201C",
        "80": "#5E1613",
        "05": "#FBEBEA"
    },
    "ink": {
        "50": "#69727D",
        "80": "#333333",
        "95": "#151515"
    },
    "surface": {
        "00": "#FFFFFF",
        "01": "#FBFBFB",
        "02": "#F5F9FE"
    },
    "line": {
        "10": "#E2E6EE",
        "15": "#CBD3E2",
        "40": "#808FA6"
    },
    "focus": {
        "ring-outer": "#151515",
        "ring-inner": "#FFFFFF"
    }
};
/** Grade dan rasio kontras terukur per swatch — dibaca gerbang kontras UX. */
export const colorMeta = {
    "navy": {
        "70": {
            "grade": 70,
            "contrastOnWhite": 10.18,
            "$description": "Primary buttons, statistics, the ASSIST mark's lower arc. Carries identity."
        },
        "80": {
            "grade": 80,
            "contrastOnWhite": 13.15,
            "$description": "Hover state for navy surfaces; dark end of the gradient."
        },
        "90": {
            "grade": 90,
            "contrastOnWhite": 17.07,
            "$description": "Pressed state for navy surfaces."
        }
    },
    "blue": {
        "10": {
            "grade": 10,
            "$description": "Information badge background, progress track fill."
        },
        "55": {
            "grade": 55,
            "contrastOnWhite": 5.69,
            "$description": "Actions, links, active navigation. Carries action."
        },
        "65": {
            "grade": 65,
            "contrastOnWhite": 7.75,
            "$description": "Hover state for blue actions and links."
        },
        "75": {
            "grade": 75,
            "contrastOnWhite": 11.15,
            "$description": "Pressed state for blue actions."
        },
        "05": {
            "grade": 5,
            "$description": "Panel and section background, active nav background."
        }
    },
    "success": {
        "60": {
            "grade": 60,
            "contrastOnWhite": 6.54,
            "$description": "A finished or healthy state: approved, implemented, verified, passed, normal. ISO 3864 green = safe condition."
        },
        "70": {
            "grade": 70,
            "contrastOnWhite": 9.37,
            "$description": "Hover state for success actions."
        },
        "05": {
            "grade": 5,
            "$description": "Success badge and banner background."
        }
    },
    "warn": {
        "60": {
            "grade": 60,
            "contrastOnWhite": 6.16,
            "$description": "Needs attention, nothing broken yet. ISO 3864 amber = caution."
        },
        "70": {
            "grade": 70,
            "contrastOnWhite": 9.38,
            "$description": "Hover state for warning actions."
        },
        "05": {
            "grade": 5,
            "$description": "Attention badge and banner background."
        }
    },
    "danger": {
        "60": {
            "grade": 60,
            "contrastOnWhite": 6.56,
            "$description": "Safety-classified record, breached deadline, destructive action, failed request. ISO 3864 red = danger/stop."
        },
        "70": {
            "grade": 70,
            "contrastOnWhite": 9.32,
            "$description": "Hover state for destructive actions."
        },
        "80": {
            "grade": 80,
            "contrastOnWhite": 12.17,
            "$description": "Pressed state for destructive actions. Audit F-01: this variable existed in the Figma collection PQM Brand and was MISSING from the export, so the destructive button was the only button in the system with no pressed feedback - ui.css gave it :hover and nothing for :active."
        },
        "05": {
            "grade": 5,
            "$description": "Danger badge and banner background."
        }
    },
    "ink": {
        "50": {
            "grade": 50,
            "contrastOnWhite": 4.88,
            "$description": "Lightest grey permitted for text. Allowed on white, surface/01 and surface/02 only - it measures 4.40:1 on the success tint and 4.22:1 on the danger tint, so it is not allowed there."
        },
        "80": {
            "grade": 80,
            "contrastOnWhite": 12.63,
            "$description": "Body text. The only grey permitted on a tinted surface."
        },
        "95": {
            "grade": 95,
            "contrastOnWhite": 18.26,
            "$description": "Headings on white. Also the outer half of the focus ring."
        }
    },
    "surface": {
        "00": {
            "grade": 0,
            "$description": "Card surface. Also the inner half of the focus ring."
        },
        "01": {
            "grade": 0,
            "$description": "Top bar, table header."
        },
        "02": {
            "grade": 0,
            "$description": "Application page background. A layering step, not a contrast step."
        }
    },
    "line": {
        "10": {
            "grade": 10,
            "contrastOnWhite": 1.25,
            "$description": "Card edges and dividers. Decorative - deliberately below the 3:1 threshold, so never used as the boundary of an interactive control."
        },
        "15": {
            "grade": 15,
            "contrastOnWhite": 1.5,
            "$description": "Secondary button border, where the label already identifies the control."
        },
        "40": {
            "grade": 40,
            "contrastOnWhite": 3.28,
            "$description": "Boundary of a control identified only by its edge: text input, checkbox, radio, toggle track. Satisfies WCAG 2.2 1.4.11."
        }
    },
    "focus": {
        "ring-outer": {
            "$description": "Outer half of the focus indicator, 2 px."
        },
        "ring-inner": {
            "$description": "Inner half of the focus indicator, 2 px, between the control and the outer ring."
        }
    }
};
export const feedback = {
    "information": {
        "fg": "#2251FF",
        "bg": "#F0F7FE",
        "shape": "circle",
        "contrastOnWhite": 5.69,
        "contrastOnOwnTint": 5.27,
        "whiteOnSolid": 5.69,
        "signalWord": {
            "en": "Information",
            "id": "Informasi"
        }
    },
    "success": {
        "fg": "#0F6B45",
        "bg": "#EAF6F0",
        "shape": "square",
        "contrastOnWhite": 6.54,
        "contrastOnOwnTint": 5.9,
        "whiteOnSolid": 6.54,
        "signalWord": {
            "en": "Success",
            "id": "Berhasil"
        }
    },
    "warning": {
        "fg": "#9A4C07",
        "bg": "#FCF0E1",
        "shape": "triangle",
        "contrastOnWhite": 6.16,
        "contrastOnOwnTint": 5.48,
        "whiteOnSolid": 6.16,
        "signalWord": {
            "en": "Warning",
            "id": "Perhatian"
        }
    },
    "danger": {
        "fg": "#B02A24",
        "bg": "#FBEBEA",
        "shape": "octagon",
        "contrastOnWhite": 6.56,
        "contrastOnOwnTint": 5.67,
        "whiteOnSolid": 6.56,
        "signalWord": {
            "en": "Error",
            "id": "Gagal"
        }
    }
};
export const toastTiming = {
    "$description": "WCAG 2.2 2.2.1 Timing Adjustable - anything the user must read cannot disappear before they can read it.",
    "successMs": 5000,
    "informationMs": 5000,
    "warningMs": 8000,
    "errorMs": null,
    "pauseOnHoverOrFocus": true,
    "closeButtonAlwaysPresent": true,
    "maxVisible": 3,
    "placementConsole": "bottom-left, clear of the primary action at top-right",
    "placementFieldApp": "above the tab bar, 16px inset",
    "oneActionOneToast": true,
    "stateIsNotAnEvent": "A persistent condition such as 'Offline - 2 reports waiting' is a bar, not a toast."
};
export const focusIndicator = {
    "$description": "WCAG 2.2 2.4.7. A single ring cannot work on every background - blue on navy measures 1.79:1. Two rings solve it: whatever sits behind, at least one half clears 3:1.",
    "outerWidth": "2px",
    "innerWidth": "2px",
    "offset": "0px",
    "verified": {
        "white / surface-01 / surface-02": {
            "outer": "17.27-18.26",
            "inner": "1.00-1.06"
        },
        "navy-70": {
            "outer": 1.79,
            "inner": 10.18
        },
        "blue-55": {
            "outer": 3.21,
            "inner": 5.69
        },
        "danger-60": {
            "outer": 2.78,
            "inner": 6.56
        },
        "success-60": {
            "outer": 2.79,
            "inner": 6.54
        },
        "warn-60": {
            "outer": 2.97,
            "inner": 6.16
        }
    }
};
export const radius = {
    "$description": "TWO radii are in use, not three. Audit finding F-02 read all ten Figma component sets one by one: the values actually used are 999 (Button in all 25 variants, Badge, Avatar, the trend pill, the nav count pill) and 12 (Input, Nav item, Stat card, Toast, Alert banner). NOT ONE component uses radius/control.",
    "card": {
        "$type": "dimension",
        "$value": "12px",
        "$description": "Cards, inputs, nav items, stat cards, toasts, alert banners. Verified against Figma 14:11, 14:23, 14:55, 87:42, 87:75."
    },
    "control": {
        "$type": "dimension",
        "$value": "8px",
        "$description": "Radius of a small SQUARE control box. Exactly one legitimate user in the whole system, named here so that it can never again be a promise nobody kept: the 24x24 box of the Checkbox component set (Figma 163:18), rendered by .assist-checkbox__box. NOT for buttons (radius/pill), NOT for inputs (radius/card), NOT for nav items (radius/card), NOT for cards (radius/card). History, because it explains why the rule is written this way: this token had NO user at all, and that absence is the root cause of audit finding K-01 -- the single largest deviation in the project. The export promised a 'control radius' and every developer reasonably believed that was the radius of a control, so every button, input and nav item was built at 8px while Figma draws them at 999 and 12, across 28 screens. It was marked $deprecated as a stopgap; the designer then gave it one real user and wrote the rule down. tools/ci/gerbang-token-figma.mjs now enforces EXACTLY ONE user via `pemakai_tunggal` in packages/design-tokens/variabel-figma.json: zero users fails the build and two users fails it as well."
    },
    "pill": {
        "$type": "dimension",
        "$value": "999px",
        "$description": "Buttons (all types), badges, avatars, the stat trend pill, the nav count pill, the language switch, the search field. Verified against Figma 13:15, 107:17, 13:37."
    }
};
export const space = {
    "1": {
        "$type": "dimension",
        "$value": "4px"
    },
    "2": {
        "$type": "dimension",
        "$value": "8px"
    },
    "3": {
        "$type": "dimension",
        "$value": "12px"
    },
    "4": {
        "$type": "dimension",
        "$value": "16px"
    },
    "5": {
        "$type": "dimension",
        "$value": "24px"
    },
    "6": {
        "$type": "dimension",
        "$value": "32px"
    }
};
export const typography = {
    "$description": "Inter only, in four weights. Same family as pqm.co.id.",
    "family": {
        "$type": "fontFamily",
        "$value": "Inter"
    },
    "weight": {
        "regular": {
            "$type": "fontWeight",
            "$value": 400
        },
        "medium": {
            "$type": "fontWeight",
            "$value": 500
        },
        "semibold": {
            "$type": "fontWeight",
            "$value": 600
        },
        "bold": {
            "$type": "fontWeight",
            "$value": 700
        }
    },
    "scale": {
        "pageHeading": {
            "$type": "typography",
            "$value": {
                "fontSize": "32px",
                "fontWeight": 700,
                "letterSpacing": "-2%"
            }
        },
        "cardHeading": {
            "$type": "typography",
            "$value": {
                "fontSize": "18px",
                "fontWeight": 700
            }
        },
        "statistic": {
            "$type": "typography",
            "$value": {
                "fontSize": "30px",
                "fontWeight": 700,
                "letterSpacing": "-2%"
            }
        },
        "tableRow": {
            "$type": "typography",
            "$value": {
                "fontSize": "14.5px",
                "fontWeight": 600
            }
        },
        "body": {
            "$type": "typography",
            "$value": {
                "fontSize": "14px",
                "fontWeight": 400,
                "lineHeight": "160%"
            }
        },
        "label": {
            "$type": "typography",
            "$value": {
                "fontSize": "13px",
                "fontWeight": 500
            }
        },
        "meta": {
            "$type": "typography",
            "$value": {
                "fontSize": "12px",
                "fontWeight": 400
            }
        }
    }
};
export const icon = {
    "$description": "Line icons on a 24 grid, rounded caps and joins. The stroke is held optically constant - it does not shrink with the icon. Compute the SVG stroke-width as visualStroke * 24 / renderedSize.",
    "sidebarNav": {
        "size": "20px",
        "visualStroke": "1.7px"
    },
    "fieldTabBar": {
        "size": "22px",
        "visualStroke": "1.8px"
    },
    "listRow": {
        "size": "20px",
        "visualStroke": "1.7px"
    },
    "insideButton": {
        "size": "18px",
        "visualStroke": "1.6px"
    },
    "smallLabel": {
        "size": "16px",
        "visualStroke": "1.5px"
    },
    "emptyState": {
        "size": "32px",
        "visualStroke": "2.0px"
    }
};
export const shell = {
    "sidebarWidth": {
        "$type": "dimension",
        "$value": "248px"
    },
    "topBarHeight": {
        "$type": "dimension",
        "$value": "72px"
    },
    "consoleFrame": {
        "$value": "1440 x 900"
    },
    "fieldFrame": {
        "$value": "390 x 844"
    },
    "fieldTouchTarget": {
        "$type": "dimension",
        "$value": "56px"
    }
};
export const localeSpec = {
    "$description": "ASSIST ships in two languages. Language is a user preference; the tenant sets the default for new accounts. A missing key falls back to the English string and is logged - never a blank, never a raw key.",
    "supported": [
        "en",
        "id"
    ],
    "default": "en",
    "textExpansionAllowance": "Bahasa Indonesia runs 15-25% longer. Size buttons, table headers and navigation against the Indonesian string.",
    "navLabelMaxChars": 22,
    "format": {
        "en": {
            "date": "25 Sep 2026",
            "time": "09:47",
            "number": "1,842",
            "decimal": "99.94%",
            "currency": "IDR 4,200,000",
            "currencyShort": "IDR 12.4M",
            "firstDayOfWeek": "monday"
        },
        "id": {
            "date": "25 Sep 2026",
            "time": "09.47 WIB",
            "number": "1.842",
            "decimal": "99,94%",
            "currency": "Rp 4.200.000",
            "currencyShort": "Rp 12,4 jt",
            "firstDayOfWeek": "senin"
        }
    },
    "neverTranslate": [
        "Names of people, areas, plants and companies",
        "Record IDs: TMN-, IDE-, PRJ-, TEN-, USR-",
        "Module codes M01-M15 and kernel letters A, B, C, D, P",
        "API error codes such as ENTITLEMENT_REQUIRED",
        "Free text typed by users"
    ],
    "fiveS": {
        "$description": "Both label sets map to the same stored category code, so a report reads in either language without re-tagging data.",
        "S1": {
            "code": "sort",
            "en": "Sort",
            "id": "Ringkas"
        },
        "S2": {
            "code": "set_in_order",
            "en": "Set in order",
            "id": "Rapi"
        },
        "S3": {
            "code": "shine",
            "en": "Shine",
            "id": "Resik"
        },
        "S4": {
            "code": "standardize",
            "en": "Standardize",
            "id": "Rawat"
        },
        "S5": {
            "code": "sustain",
            "en": "Sustain",
            "id": "Rajin"
        }
    }
};
export const tenantBranding = {
    "$description": "Logo, display name and one accent colour are tenant data, not build-time assets. Everything else stays with ASSIST.",
    "logo": {
        "formats": [
            "svg",
            "png-transparent"
        ],
        "minLongestSide": "256px",
        "renderedIn": "32 x 32 box"
    },
    "displayName": {
        "maxChars": 22,
        "case": "uppercase"
    },
    "accentColor": {
        "count": 1,
        "minContrastOnWhite": 4.5
    },
    "appIcon": {
        "availableOn": "full white-label plan only"
    },
    "fallback": "No logo uploaded renders the tenant initials on an accent-coloured tile.",
    "permission": "identity.manage",
    "audited": true
};
export const gradeScale = {
    "$description": "Grade = 100 minus measured perceptual lightness (CIE L*). 0 is white, 100 is black. A grade difference of 50 or more clears WCAG AA for body text; 40 or more clears AA for large text and for non-text. The rule is a guide - every pairing in this file was measured, not assumed.",
    "aaBodyTextMinimumGradeDifference": 50,
    "aaLargeTextAndNonTextMinimumGradeDifference": 40
};
export const standards = {
    "$description": "There is no ISO standard palette for application interfaces. What is normative is how colour must behave; what is conventional is the method for building the ramp. Both are cited so nobody has to guess which is binding.",
    "normative": [
        {
            "id": "WCAG 2.2",
            "status": "W3C Recommendation",
            "binds": "1.4.3 text contrast 4.5:1 (3:1 large) · 1.4.11 non-text contrast 3:1 · 1.4.1 colour is never the only carrier · 2.4.7 focus visible · 2.2.1 timing adjustable · 4.1.3 status messages",
            "url": "https://www.w3.org/TR/WCAG22/"
        },
        {
            "id": "ISO/IEC 40500",
            "status": "International Standard",
            "binds": "WCAG published under an ISO number - the same rules in the form procurement usually asks for"
        },
        {
            "id": "EN 301 549 v4.1.1",
            "status": "European standard, September 2026",
            "binds": "Adopts WCAG 2.2 AA. The legally cited version remains v3.2.1 (WCAG 2.1) until the European Commission updates the Official Journal"
        },
        {
            "id": "ISO 3864-1 / IEC 60073",
            "status": "International Standard",
            "binds": "Meaning of the safety colours: red stop, amber caution, green safe condition, blue information"
        },
        {
            "id": "ANSI Z535.4",
            "status": "American National Standard",
            "binds": "Signal words: Danger, Warning, Caution, Notice"
        },
        {
            "id": "ISO 9241-112",
            "status": "International Standard",
            "binds": "Presentation of information - coding must be redundant, never colour-only"
        }
    ],
    "conventional": [
        {
            "id": "USWDS colour grades",
            "status": "Not a standard",
            "binds": "The graded lightness scale and the magic-number rule, adopted here deliberately",
            "url": "https://designsystem.digital.gov/design-tokens/color/overview/"
        },
        {
            "id": "Material Design 3 tonal palettes",
            "status": "Not a standard",
            "binds": "Same idea, different numbering"
        }
    ]
};
//# sourceMappingURL=tokens.generated.js.map